import _ from "lodash";
import {useIntl} from "react-intl";
import {useState} from "react";

export function formatDate(date) {
    if (date) {
        // used for fixing server date format to work with safari
        return date.replace(/\s/g, 'T') + ":00"
    }
}

export function validUntilDate(date) {
    if (date) {
        return date.getFullYear() + "-"
            + ("0" + (date.getMonth() + 1)).slice(-2) + "-"
            + ("0" + date.getDate()).slice(-2)
    }
}

function formatTimezoneOffset(date) {
    let offset = date.getTimezoneOffset()
    let sign = offset > 0 ? "-" : "+"
    // Ensure offset is positive for the division and padding
    offset = Math.abs(offset)
    let hours = Math.floor(offset / 60)
    let minutes = offset % 60
    let formattedOffset = sign + ("0" + hours).slice(-2)
    // Append minutes only if they are not zero
    if (minutes !== 0) {
        formattedOffset += ("0" + minutes).slice(-2)
    }
    return formattedOffset
}

export function dateToServerFormatWithZeroSeconds(date) {
    if (date) {
        // Set seconds to zero
        date.setSeconds(0)

        // Format the date into YYYY-MM-DD HH:MM:SS±HHMM format
        return date.getFullYear() + "-"
            + ("0" + (date.getMonth() + 1)).slice(-2) + "-"
            + ("0" + date.getDate()).slice(-2) + " "
            + ("0" + date.getHours()).slice(-2) + ":"
            + ("0" + date.getMinutes()).slice(-2) + ":"
            + ("0" + date.getSeconds()).slice(-2) // Seconds will be "00" after reset
            + formatTimezoneOffset(date)
    } else {
        // Handle null or undefined date input
        throw new Error('Invalid date provided')
    }
}

export function dateToServerFormat(date) {
    // TODO: check utc timezone handling
    if (date) {
        return date.getFullYear() + "-"
            + ("0" + (date.getMonth() + 1)).slice(-2) + "-"
            + ("0" + date.getDate()).slice(-2) + " "
            + ("0" + date.getHours()).slice(-2) + ":"
            + ("0" + date.getMinutes()).slice(-2) + ":"
            + ("0" + date.getSeconds()).slice(-2)
            + formatTimezoneOffset(date)
    }
}

export function updateTimeToServerFormat(date) {
    // TODO: check utc timezone and milliseconds handling
    if (date) {
        return date.getFullYear() + "-"
            + ("0" + (date.getMonth() + 1)).slice(-2) + "-"
            + ("0" + date.getDate()).slice(-2) + " "
            + ("0" + date.getHours()).slice(-2) + ":"
            + ("0" + date.getMinutes()).slice(-2) + ":"
            + ("0" + date.getSeconds()).slice(-2) + "."
            + date.getMilliseconds()
            + (date.getTimezoneOffset > 0 ? "-" : "+")
            + (("0" + (-date.getTimezoneOffset() / 60)).slice(-2))
    }
}

export function shadeColor(color, percent) {

    let R = parseInt(color.substring(1,3),16);
    let G = parseInt(color.substring(3,5),16);
    let B = parseInt(color.substring(5,7),16);

    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);

    R = (R<255)?R:255;
    G = (G<255)?G:255;
    B = (B<255)?B:255;

    let RR = ((R.toString(16).length===1)?"0"+R.toString(16):R.toString(16));
    let GG = ((G.toString(16).length===1)?"0"+G.toString(16):G.toString(16));
    let BB = ((B.toString(16).length===1)?"0"+B.toString(16):B.toString(16));

    return "#"+RR+GG+BB;
}

export function formatUserDataForPost(user, trim, clearValidUntil) {
    if (!user) {
        return null
    }
    const userCopy = _.cloneDeep(user)
    let userData = {}
    let userMeta = {}
    Object.keys(userCopy).forEach((key)=>{
        const keyIsTopLevel = key === 'id' || key === 'iv' || key === 'notifications' || key === 'superuser' || key === 'validuntil'
        if (keyIsTopLevel) {
            userData[key] = userCopy.hasOwnProperty(key) ? trim ? userCopy[key].trim() : userCopy[key] : null
            if (key === "superuser") {
                if (userData[key] === "true") {
                    userData[key] = 1
                }
                if (userData[key] === "false") {
                    userData[key] = 0
                }
            }
        } else if (key === 'aliases' && Array.isArray(userCopy[key])) {
            userMeta[key] = userCopy[key].map(alias => trim ? alias.trim() : alias)
        } else {
            userMeta[key] = userCopy.hasOwnProperty(key) ? trim ? userCopy[key].trim() : userCopy[key] : null
        }
    })
    if (clearValidUntil) {
        userData.validuntil = null
    }
    userData.meta = userMeta
    return userData
}

export function formatTranslationsToIntl(data) {
    if (!data) {
        return null
    }
    let intlObj = {}
    for (let i = 0; i < data.length; i++) {
        const langObj = data[i]
        intlObj[langObj.field] = langObj.value
    }
    return intlObj
}

export function findTopLevelParent(config, branchKey) {
    function helper(tree, target, parent, depth) {
        for (let key in tree) {
            if (key === target) {
                return {parent, depth}
            }

            if (typeof tree[key] === 'object' && tree[key] !== null) {
                let found = helper(tree[key], target, parent || key, depth + 1)
                if (found) return found
            }
        }
    }
    return helper(config, branchKey, null, 0)
}

export const calculateSlice = (data, key, maxChars) => {
    let totalChars = 0;
    let sliceCount = 0;
    for (let i = 0; i < data.length; i++) {
        let value = data[i]?.data[key];
        if (typeof value !== 'string') {
            value = String(value); // Convert to string if not already a string
        }
        let newTotalChars = totalChars + value.length;
        if (newTotalChars > maxChars) {
            break;
        }
        totalChars = newTotalChars;
        sliceCount++;
    }
    return sliceCount;
}

export function formatMissingRows(missingRows) {
    const rowsCopy = [...missingRows]
    if (missingRows.length === 0) {
        return ""
    } else if (missingRows.length === 1) {
        return `${missingRows[0] + 2}`
    } else if (missingRows.length > 10) {
        return `${missingRows.map(index => index + 2).join(', ')}...`
    } else {
        const lastIndex = rowsCopy.pop();
        return `${rowsCopy.map(index => index + 2).join(', ')} & ${lastIndex + 2}`
    }
}

export function FormatPhoneNumberDisplay({phonenumberArray, intl}) {
    const [showAllInvalid, setShowAllInvalid] = useState(false)

    if (phonenumberArray.length === 0) {
        return "";
    } else if (phonenumberArray.length === 1) {
        return `\n\n- ${phonenumberArray[0]}\n\n`
    } else if (phonenumberArray.length > 5 && !showAllInvalid) {
        const amountOver = <button onClick={() => setShowAllInvalid(true)}>{`\n+ ${phonenumberArray.length - 5} ${intl.formatMessage({id:'more', defaultMessage:'more'})}\n\n`}</button>
        return <>{`\n\n- ${phonenumberArray.slice(0,5).join('\n- ')}`}{amountOver}</>
    } else {
        return `\n\n- ${phonenumberArray.join('\n- ')}\n\n`
    }
}

export function extractValuesByKey(dataArray, key) {
    let uniqueValues = new Set()

    dataArray.forEach(item => {
        let values = item.data[key]

        // If has multiple values separated by comma
        if (typeof values === 'string' && values.includes(',')) {
            values = values.split(',').map(v => v.trim())
        } else {
            values = [values]
        }

        values.forEach(value => {
            if (value !== null) {
                uniqueValues.add(value)
            }
        })
    })

    return Array.from(uniqueValues)
}

export function transformContactUploadDataForPost(objectA, objectB) {
    const transformedObjectA = _.cloneDeep(objectA)

    // Removing keys with null values from extracolumn
    for (const key in transformedObjectA.extracolumn) {
        if (transformedObjectA.extracolumn[key] === null) {
            delete transformedObjectA.extracolumn[key]
        }
    }

    // Creating a reverse lookup object from objectB
    const columnToKeyMap = {}
    for (const key in objectB) {
        const columnValue = objectB[key].column
        if (columnValue) {
            columnToKeyMap[columnValue] = key
        }
    }

    // Editing objects in contacts array
    transformedObjectA.contacts.forEach((contact) => {
        const originalData = { ...contact.data }
        contact.data = {}

        for (const key in originalData) {
            // Use the new key if it exists, otherwise use the original key
            const newKey = columnToKeyMap[key]
            if (newKey) {
                contact.data[newKey] = originalData[key]
            } else if (transformedObjectA.extracolumn[key]) {
                // do not change the key for extracolumns since backend uses this key to find correct annieuser for role mappings
                contact.data[key] = originalData[key]
            }
        }
    })

    return transformedObjectA
}

export function debounceFunction(callback, delay) {
    let timeout

    function debounce() {
        clearTimeout(timeout)
        timeout = setTimeout(callback, delay)
    }

    debounce.flush = function() {
        clearTimeout(timeout)
        callback()
    }

    debounce.cancel = function() {
        clearTimeout(timeout)
    }

    return debounce
}